import { useCallback, useContext, useMemo } from "react";

import SessionContext from "app/contexts/SessionContext";
import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useClientFamilyCorpFilters = () => {
    const session = useContext(SessionContext);
    const { getDataAsync } = useApi();

    const buildFetch = useCallback(
        (endpointName) => async () => {
            const response = await getDataAsync(endpointName, {
                urlParams: [
                    { name: "$active", value: "" },
                    { name: "$userId", value: session.id },
                    { name: "$agencyId", value: session.agencyId },
                    { name: "$isAdmin", value: session.isLegacyAdminUser },
                ],
            });
            return response.status === 204 ? null : response.json();
        },
        [getDataAsync, session.id, session.agencyId, session.isLegacyAdminUser]
    );

    const agencyList = useQuery("core-agencies-selectorList", buildFetch("core-agencies-selector"));
    const familyList = useQuery("projects-clientfamilies-selectorList", buildFetch("projects-clientfamilies-selector"));
    const clientList = useQuery("projects-clients-selectorList", buildFetch("projects-clients-selector"));
    const corporateList = useQuery("projects-corporate-selectorList", buildFetch("projects-corporate-selector"));

    return useMemo(
        () => ({ agencyList, familyList, clientList, corporateList }),
        [agencyList, familyList, clientList, corporateList]
    );
};

export default useClientFamilyCorpFilters;
